interface IBrandingConfig {
  webUrl: string;
  siteUrl: string;
  supportEmail: string;
  instagramUrl: string;
}

export default {
  webUrl: process.env.REACT_APP_WEB_URL || 'https://app.trenzox.com',

  siteUrl: process.env.REACT_APP_SITE_URL || 'https://www.trenzox.com',

  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || 'suporte@trenzox.com',

  instagramUrl:
    process.env.REACT_APP_INSTAGRAM_URL ||
    'https://www.instagram.com/trenzox.app/',
} as IBrandingConfig;
